// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PictureFilledSvg from "@ant-design/icons-svg/es/asn/PictureFilled";
import AntdIcon from '../components/AntdIcon';

var PictureFilled = function PictureFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureFilledSvg
  }));
};

PictureFilled.displayName = 'PictureFilled';
export default React.forwardRef(PictureFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PictureFilled.js
// module id = 1565
// module chunks = 0